import { Stack, Checkbox, Typography } from '@mui/material';
import React from 'react';

const CheckboxForm = ({
    id, value, label, onChange
}) => {

    const onInnerChange = (e, value) => {
        const data2send = {[e.target.id]:value ? 1 : 0}
        onChange(data2send)

    } 

    return ( 
        <Stack direction='row' alignItems='center'>
            <Checkbox id={id} checked={Boolean(value)} onChange={onInnerChange}/>
            <Typography>{label}</Typography>
        </Stack>
     );
}
 
export default CheckboxForm;